import Axios, { authHeaders } from "../../utils/axios";

/**
 * Admin feedback API. Every call is scoped to one product; the backend checks
 * feedback_<product> permissions on each, so these never see the other
 * product's data whatever the caller passes.
 */

const unwrap = (err) => {
    const message = err?.response?.data?.message || err?.message || "Request failed";
    return Object.assign(new Error(message), { status: err?.response?.status });
};

export const listFeedback = async (product, params) => {
    try {
        const res = await Axios.get(`/feedback/${product}`, { ...authHeaders(), params });
        return res.data; // { data, meta }
    } catch (err) {
        throw unwrap(err);
    }
};

export const getFeedback = async (product, id) => {
    try {
        const res = await Axios.get(`/feedback/${product}/${id}`, authHeaders());
        return res.data.data;
    } catch (err) {
        throw unwrap(err);
    }
};

export const updateFeedback = async (product, id, patch) => {
    try {
        const res = await Axios.patch(`/feedback/${product}/${id}`, patch, authHeaders());
        return res.data.data;
    } catch (err) {
        throw unwrap(err);
    }
};

/**
 * An attachment as an object URL. Attachments are private, so an <img src> or
 * link to the API would have no Authorization header — fetch the bytes with it
 * instead. The caller revokes the URL when done.
 */
export const fetchAttachmentUrl = async (product, id, attachmentId) => {
    try {
        const res = await Axios.get(`/feedback/${product}/${id}/attachments/${attachmentId}`, {
            ...authHeaders(),
            responseType: "blob",
        });
        return URL.createObjectURL(res.data);
    } catch (err) {
        throw unwrap(err);
    }
};
